import type {
  CreateTrashLogFormValues,
  CreateTrashLogRequestDto,
  TrashLog,
  TrashLogEntry,
  TrashLogEntryDto,
  TrashLogResponseDto,
  UpdateTrashLogFormValues,
  UpdateTrashLogRequestDto,
} from './trash-log.dto';

export const mapTrashLogEntry = ({
  date_time,
  position_remarks,
  estimated_amount,
  to_sea,
  to_reception_facility,
  certification_signature,
  ...rest
}: TrashLogEntryDto): TrashLogEntry => ({
  ...rest,
  dateTime: date_time,
  positionRemarks: position_remarks,
  estimatedAmount: estimated_amount,
  toSea: to_sea,
  toReceptionFacility: to_reception_facility,
  certificationSignature: certification_signature,
});

export const mapTrashLogEntryDto = ({
  dateTime,
  positionRemarks,
  estimatedAmount,
  toSea,
  toReceptionFacility,
  certificationSignature,
  ...rest
}: TrashLogEntry): TrashLogEntryDto => ({
  ...rest,
  date_time: dateTime,
  position_remarks: positionRemarks,
  estimated_amount: estimatedAmount,
  to_sea: toSea,
  to_reception_facility: toReceptionFacility,
  certification_signature: certificationSignature,
});

export const mapTrashLog = ({
  vessel_id,
  vessel_name,
  vessel_registration_no,
  vessel_imo_number,
  captain_id,
  captain_name,
  captain_signed_at,
  created_at,
  updated_at,
  entries,
  ...rest
}: TrashLogResponseDto): TrashLog => ({
  ...rest,
  vesselId: vessel_id,
  vesselName: vessel_name,
  vesselRegistrationNo: vessel_registration_no,
  vesselImoNumber: vessel_imo_number,
  captainId: captain_id,
  captainName: captain_name,
  captainSignedAt: captain_signed_at,
  createdAt: created_at,
  updatedAt: updated_at,
  entries: (entries ?? []).map(mapTrashLogEntry),
});

const toRfc3339 = (date: string): string => {
  const d = new Date(date.length === 10 ? `${date}T00:00:00.000Z` : date);
  return Number.isNaN(d.getTime()) ? date : d.toISOString();
};

export const mapCreateTrashLogDto = ({
  date,
  entries,
}: CreateTrashLogFormValues): CreateTrashLogRequestDto => ({
  date: toRfc3339(date),
  entries: entries?.map(mapTrashLogEntryDto),
});

export const mapUpdateTrashLogDto = ({
  id,
  entries,
}: UpdateTrashLogFormValues): UpdateTrashLogRequestDto => ({
  id,
  entries: entries?.map(mapTrashLogEntryDto),
});
